// Le registre des écrans d'étape. Le code de l'étape est la seule clé —
// ajouter une étape, c'est ajouter une ligne au modèle SQL, une au modèle TS
// et une ici.

import type { ComponentType } from 'react'
import type { PropsEtape } from './types'
import Import from './Import'
import Apports from './Apports'
import ApportSco from './ApportSco'
import Pad from './Pad'
import Prelevements from './Prelevements'
import Tickets from './Tickets'
import RapportOperateurs from './RapportOperateurs'
import Depouillement from './Depouillement'
import PrelevementsSco from './PrelevementsSco'
import Coffre from './Coffre'
import ColMnc from './ColMnc'

export type { PropsEtape } from './types'

export const ECRANS: Record<string, ComponentType<PropsEtape>> = {
  '01': Import,
  '02': Apports,
  '02A': ApportSco,
  '03': Pad,
  '04': Prelevements,
  // 05A réunit le rapport opérateur et les opérations à risque : l'écran des
  // « opérations à risque » n'existe plus seul, son contenu vit là-dedans.
  '05A': RapportOperateurs,
  '05B': Depouillement,
  '06': PrelevementsSco,
  '07': Tickets,
  '08': Tickets,
  '09': Tickets,
  '10': Coffre,
  '11': ColMnc,
}
